module.exports = __webpack_public_path__ + "img/66.d0e46d9d.png";